import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardColorIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20.44 3.12C18.18 1.11 15.18 0 12 0C5.38 0 0 5.38 0 12C0 18.62 5.38 24 12 24C13.56 24 14.83 22.73 14.83 21.22C14.88 20.38 14.48 19.8 14.19 19.37C13.97 19.06 13.89 18.91 13.9 18.72C13.9 18.26 14.27 17.89 14.73 17.89H16.89C20.81 17.89 24 14.7 24 10.78C24 7.88 22.74 5.16 20.44 3.12ZM16.89 15.89H14.73C13.17 15.89 11.9 17.16 11.9 18.67C11.86 19.51 12.26 20.08 12.55 20.51C12.77 20.82 12.85 20.97 12.84 21.17C12.84 21.63 12.47 22 12.01 22C6.5 22 2.01 17.51 2.01 12C2.01 6.49 6.49 2 12 2C14.69 2 17.22 2.93 19.11 4.61C20.97 6.26 22 8.45 22 10.78C22 13.6 19.71 15.89 16.89 15.89Z"
        fill={color}
      />
      <path
        d="M5.28003 12.17C6.3846 12.17 7.28003 11.2746 7.28003 10.17C7.28003 9.06544 6.3846 8.17001 5.28003 8.17001C4.17546 8.17001 3.28003 9.06544 3.28003 10.17C3.28003 11.2746 4.17546 12.17 5.28003 12.17Z"
        fill={color}
      />
      <path
        d="M8.93994 7.28C10.0445 7.28 10.9399 6.38457 10.9399 5.28C10.9399 4.17543 10.0445 3.28 8.93994 3.28C7.83537 3.28 6.93994 4.17543 6.93994 5.28C6.93994 6.38457 7.83537 7.28 8.93994 7.28Z"
        fill={color}
      />
      <path
        d="M15.0601 7.28C16.1646 7.28 17.0601 6.38457 17.0601 5.28C17.0601 4.17543 16.1646 3.28 15.0601 3.28C13.9555 3.28 13.0601 4.17543 13.0601 5.28C13.0601 6.38457 13.9555 7.28 15.0601 7.28Z"
        fill={color}
      />
      <path
        d="M18.72 12.17C19.8245 12.17 20.72 11.2746 20.72 10.17C20.72 9.06544 19.8245 8.17001 18.72 8.17001C17.6154 8.17001 16.72 9.06544 16.72 10.17C16.72 11.2746 17.6154 12.17 18.72 12.17Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardColorIcon.displayName = 'BoardColorIcon';
